export interface BigNumbersPreviewItemProps {
  code: PreviewsStatusProps
  descriptionEn?: string
  descriptionPtbr?: string
  id?: number
}

export const PreviewsStatus = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  RELEASED: 'released',
  GO_VALIDATION: 'go_validation',
  RETURNED_GCE: 'returned_gce', // TODO confirm with product team
  RETURNED_GU: 'returned_gu',
  CONTROLLER_VALIDATION: 'controller_validation',
  RETURNED_CONTROLLER: 'returned_controller',
  DIRECTOR_VALIDATION: 'director_validation',
  HEAD_FINANCE_VALIDATION: 'head_finance_validation',
  RETURNED_HEAD_FINANCE: 'returned_head_finance',
  VP_APPROVAL: 'vp_approval',
  COMPLETED: 'completed', // TODO confirm with product team

  // TOTO estavam faltando e não estão mapeados no componente BudgetPreviewsStatus
  RELEASED_SEND: 'released_send',
  GCE_VALIDATION: 'gce_validation',
  GO_VALIDATION_COMPLETED: 'go_validation_completed',
  DIRECTOR_VALIDATION_COMPLETED: 'director_validation_completed',
  COMPLETED_GO_VALIDATION: 'completed_go_validation'
} as const

export type PreviewsStatusProps = (typeof PreviewsStatus)[keyof typeof PreviewsStatus]

export interface BudgetPreviewsStatusProps {
  status: BigNumbersPreviewItemProps
  // Tag menor e sem ícone, para cabeçalhos de tabela/card
  compact?: boolean
}
